/**
 * A RUN-TIME COUNTER IN HOURS — one helper, read by the Overview's "Run today", the Backup tab's run
 * days and the generator's health, so the three can never convert a counter two ways. Alone in its
 * module because `dc-backup.ts` imports `dc-quality.ts`, which imports the Overview's
 * `data-centre.ts`: the Overview reaching into `dc-backup.ts` for it would close a cycle.
 */

const UNIT_HOURS: Record<string, number> = { s: 1 / 3600, sec: 1 / 3600, second: 1 / 3600, seconds: 1 / 3600, min: 1 / 60, minute: 1 / 60, minutes: 1 / 60, h: 1, hr: 1, hour: 1, hours: 1 };

/**
 * A run-time counter in hours, from the unit its PARAMETER states — never guessed from the size of
 * the number. NBR's DSE7320 counts `runtime` in seconds, in 360 s steps: it moved 1,800 over a
 * 30-minute run on 16 Oct 2026 and 21,960 over the six hours of 20 Oct's night, and Parameters
 * once said "h" at scale 0.001 (4,741.56 h for 1,317). A person confirms the unit there; until one
 * is stated this answers null, and no run figure is shown.
 */
export function hoursFromUnit(value: number | null, unit: string | null | undefined): number | null {
  if (value === null || !Number.isFinite(value)) return null;
  const per = UNIT_HOURS[(unit ?? '').trim().toLowerCase()];
  return per === undefined ? null : value * per;
}
